/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Save_ErrorInputs */

const en_admin_footer_badges_save_error = /** @type {(inputs: Admin_Footer_Badges_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not update the footer badge.`)
};

/**
* | output |
* | --- |
* | "Could not update the footer badge." |
*
* @param {Admin_Footer_Badges_Save_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_save_error = /** @type {((inputs?: Admin_Footer_Badges_Save_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Save_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_save_error(inputs)
});
export { admin_footer_badges_save_error as "admin.footer_badges.save_error" }